/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function scan(params) {
    // 驿站JSBridge：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/scan_code.html?spm=a2d5h.23431112.0.0
    var formatOutput = function (ret) {
        // 统一成uni官方淘宝一致的API字段输出：https://uni-apis.alibaba-inc.com/doc/Device/scan
        // 菜鸟容器只返回result字符串，无其他属性
        var qrCode = ret === null || ret === void 0 ? void 0 : ret.result;
        return {
            code: qrCode,
            qrCode: qrCode,
            barCode: qrCode,
        };
    };
    WVCall('ScanCodeModule.scan', params, {
        formatOutput: formatOutput,
    });
}

export { scan as default };
